export default class AlertService {
  constructor($document) {
    'ngInject';

    Object.assign(this, { $document });
  }

  setScrollDisabled(isDisabled) {
    if (isDisabled) {
      this.$document[0].body.classList.add('no-scroll');
    } else {
      this.$document[0].body.classList.remove('no-scroll');
    }
  }

  isScrollDisabled() {
    return this.$document[0].body.classList.contains('no-scroll');
  }
}
